<template>
  <div id="select-tariff select-tariff__theme_default"
       class="block block__column"
  >
    <transition name="fade">
      <OfferToBuyComponent
        v-if="bonusData.isActive"
        :discountData="bonusData"
        :textButton="'Выбрать тариф'"
        :enableScroll="true"
        :scrollId="'tariff_block'"
        @closeComponent="closeDiscountComponent()"
      ></OfferToBuyComponent>
    </transition>

    <div class="tariff_container"
         id="tariff_block"
         :class="{'tariff_container__padding_top': bonusData.isActive}"
    >
      <div class="switch_container"
           v-if="showSelectTutor"
      >
        <div class="switch">
          <div class="switch_text"
               :class="(activeTypeTutor === 'standardTutor')?('switch_text__active'):('')"
               @click="setTutor('standardTutor')"
          >
            <div class="text text__desktop">Стандартный репетитор</div>
            <div class="text text__mobile">Стандартный</div>
          </div>
        </div>

        <div class="switch_block">
          <input type="checkbox"
                 class="switch_1"
                 v-model="topTutorValue"
                 @change="setTutor((topTutorValue)?('standardTutor'):('topTutor'))"
          >
        </div>

        <div class="switch">
          <div class="switch_text"
               :class="(activeTypeTutor === 'topTutor')?('switch_text__active'):('')"
               @click="setTutor('topTutor')"
          >
            <div class="text text__desktop">Топовый репетитор</div>
            <div class="text text__mobile">Топовый</div>
          </div>

          <div class="module_help module_help__theme_tutors">
            <div class="svg"
                 @mouseover="topTutorExplanationOpen = true"
                 @mouseout="topTutorExplanationOpen = false"
            >
              <div class="svg_absolute"></div>
              <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.0002 5.5C9.01196 5.5 7.39404 7.11792 7.39404 9.10617H9.22738C9.22738 8.12808 10.023 7.33333 11.0002 7.33333C11.9774 7.33333 12.773 8.12808 12.773 9.10617C12.773 9.65433 12.3321 10.0522 11.6584 10.5967C11.4246 10.7864 11.2037 10.967 11.025 11.1458C10.1101 12.0597 10.0835 13.0304 10.0835 13.1386V13.75H11.9169L11.916 13.1697C11.9169 13.1551 11.9462 12.8159 12.3202 12.4428C12.4577 12.3053 12.631 12.1678 12.8106 12.023C13.5247 11.4446 14.6055 10.571 14.6055 9.10617C14.6064 7.11792 12.9885 5.5 11.0002 5.5ZM10.0835 14.6667H11.9169V16.5H10.0835V14.6667Z"
                  fill="#C0CADC"/>
                <path
                  d="M11.0002 1.8335C5.94566 1.8335 1.8335 5.94566 1.8335 11.0002C1.8335 16.0547 5.94566 20.1668 11.0002 20.1668C16.0547 20.1668 20.1668 16.0547 20.1668 11.0002C20.1668 5.94566 16.0547 1.8335 11.0002 1.8335ZM11.0002 18.3335C6.95675 18.3335 3.66683 15.0436 3.66683 11.0002C3.66683 6.95675 6.95675 3.66683 11.0002 3.66683C15.0436 3.66683 18.3335 6.95675 18.3335 11.0002C18.3335 15.0436 15.0436 18.3335 11.0002 18.3335Z"
                  fill="#C0CADC"/>
              </svg>
            </div>

            <transition name="fade">
              <div class="help_popup"
                   v-if="topTutorExplanationOpen"
              >
                {{ topTutorExplanation }}
              </div>
            </transition>
          </div>
        </div>
      </div>

      <DefaultSelect
        v-if="isOldVersion"
        :activeTariff="activeTariff"
        :tariffList="tariffList"
        :activeTypeTutor="activeTypeTutor"
        :promoCodeApplied="promoCodeApplied"
        :benefitApplied="benefitApplied"
        :showSelectTutor="showSelectTutor"
        @selectTariff="choiceTariff"
        @applyPromo="applyPromoCode"
        @removePromo="removePromoCode"
      ></DefaultSelect>

      <PackageSelect
        v-else
        class="package-select"
        :class="{'package-select__margin_top': showSelectTutor}"
        :activeTypeTutor="activeTypeTutor"
        :activeTariff="activeTariff"
        :activePackage="activePackage"
        :listTariff="tariffList"
        :listPrize="listPrize"
        @selectTariff="choiceTariff"
        @selectPackage="choicePackage"
      ></PackageSelect>
    </div>

    <!--   Промокод для мобильных устр.  -->
    <div class="block_promocode block_promocode__mobile sidebar_item">
      <div class="sidebar_header">Промокод</div>

      <div class="sidebar_border"></div>

      <div class="block_promo">
        <div class="block block__row block__position_relative">
          <input name="promo_code"
                 class="promo_input"
                 v-model="valuePromoCode"
                 :disabled="promoCodeApplied"
                 type="text"
                 placeholder="Введите промокод"
                 @keydown.enter="applyPromoCode()"
          />

          <transition name="fade">
            <div class="button button__type_remove"
                 v-if="promoCodeApplied"
                 @click="removePromoCode()"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M12.2502 0L6.99938 5.25L1.74984 0L0 1.75L5.24954 7L0 12.25L1.74984 14L6.99938 8.75L12.2502 14L14 12.25L8.75046 7L14 1.75L12.2502 0Z"
                  fill="white" fill-opacity="1"/>
              </svg>
            </div>
          </transition>
        </div>

        <div class="promo_button"
             :class="(!promoCodeApplied && (valuePromoCode.length > 0))?('promo_button__active'):(
                 (promoCodeApplied)?('promo_button__applied'):('')
                 )"
             @click="applyPromoCode()"
        >
          <transition name="out-in">
            <div class="promo_svg" v-if="!promoCodeApplied">
              <svg width="22" height="22" viewBox="0 0 18 18"
                   fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.98098 9.3431L10.3044 9.0001L9.98098 8.65709L6.6872 5.1637L7.19141 4.62894L11.3128 9.0001L7.19141 13.3712L6.6872 12.8365L9.98098 9.3431Z"
                  fill="#ABABB2" stroke="#ABABB2"/>
              </svg>
            </div>

            <div class="promo_svg" v-else>
              <svg width="22" height="22" viewBox="0 0 22 22"
                   fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M8.98357 13.1016L6.0578 10.1758L5.96499 10.083L5.87218 10.1758L4.57602 11.472L4.48321 11.5648L4.57602 11.6576L8.89077 15.9724L8.98357 16.0652L9.07638 15.9724L17.9745 7.07428L18.0673 6.98147L17.9745 6.88866L16.6783 5.59249L16.5855 5.49969L16.4927 5.59249L8.98357 13.1016Z"
                  fill="white" stroke="white" stroke-width="0.2625"/>
              </svg>
            </div>
          </transition>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OfferToBuyComponent from '@/components/DefaultComponents/BlockComponents/OfferToBuyComponent.vue';
import DefaultSelect from "./ComposablesSelectTariff/DefaultSelect";
import PackageSelect from "./ComposablesSelectTariff/PackageSelect";

export default {
  name: "DefaultSelectTariff",

  props: {
    bonusData: { // данные для скидки на 2-й предмет
      type: Object,
      default: () => {
        return {
          isActive: false, // активна ли скидка
          text: '',
          discount: 0, // сумма скидки
          stockIds: [], // массив с id курсов, к которым применена скидка / -1 - скидка применена ко всем
          promo: '', // наименование промокода
          timeEnd: undefined, // время окончания действия скидки
        }
      }
    },

    activeTariff: { // id активного тарифного плана
      type: Number,
      default: () => {
        return undefined
      }
    },

    activePackage: { // id активного пакета
      type: Number,
      default: 0,
    },

    tariffList: { // список тарифов
      type: Array,
      default: () => {
        return []
      }
    },

    listPrize: { // объект бонусов
      type: Object,
      default: () => {
        return {}
      }
    },

    isOldVersion: { // это старая стр. оплат?
      type: Boolean,
      default: false,
    },

    typeTutor: { // активный тип репетиторов
      type: String,
      default: () => {
        return 'topTutor'
      }
    },

    promoCodeApplied: { // применен промокод?
      type: Boolean,
      default: () => {
        return false
      }
    },

    benefitApplied: { // применена скидка при покупке 2-го предмета?
      type: Boolean,
      default: () => {
        return false
      }
    },

    promoCode: { // текст промокода
      type: String,
      default: () => {
        return ''
      }
    },

    showSelectTutor: { // отобразить выбор репетитора
      type: Boolean,
      default: () => {
        return true;
      }
    },
  },

  data() {
    return {
      topTutorExplanationOpen: false, // открыто пояснение по топовому репетитору
      topTutorExplanation: 'ТОП-репетитор — это репетитор, который подготовил стобалльников, а также занимает лидирующие позиции по среднему баллу в рейтинге репетиторов', // пояснение "Кто такой топовый репетитор?"
      swiperOption: {
        slidesPerView: 'auto',
        spaceBetween: 12,
        pagination: {
          clickable: true
        }
      },
    }
  },

  created() {

  },

  mounted() {

  },

  watch: {

  },

  methods: {
    // закрыть компонент с информацией о скидке
    closeDiscountComponent() {
      this.$emit('closeDiscountComponent');
    },

    // установить тип репетитора
    setTutor(type) {
      this.activeTypeTutor = type;
      this.$emit('setTutor', type);
    },

    // выбрать тариф
    choiceTariff(id, index) {
      this.$emit('choiceTariff', id, index);
    },

    // выбрать пакет
    choicePackage(item, index) {
      this.$emit('choicePackage', item, index);
    },

    // применить промокод
    applyPromoCode() {
      this.$emit('applyPromoCode');
    },

    // удалить промокод
    removePromoCode() {
      this.$emit('removePromoCode');
    },
  },

  computed: {
    activeTypeTutor: { // активный тип репетиторов
      get() {
        return this.typeTutor
      },

      set(value) {
        this.$emit('update:typeTutor', value);
      }
    },

    // управляет значением switch "сейчас выбран топ репетитор?"
    topTutorValue: {
      get() {
        return this.activeTypeTutor === 'topTutor'
      },
      set(modelValue) {
        if (value) {
          this.$emit('update:typeTutor', 'topTutor');
          this.$emit('setTutor', 'topTutor');
        } else {
          this.$emit('update:typeTutor', 'standardTutor');
          this.$emit('setTutor', 'standardTutor');
        }
      }
    },

    valuePromoCode: { // промокод
      get() {
        return this.promoCode
      },

      set(value) {
        this.$emit('update:promoCode', value);
      }
    },
  },

  components: {
    OfferToBuyComponent,
    DefaultSelect,
    PackageSelect,
  }
}
</script>


<style lang="scss">
@import "../../../../../../style/styles_fonts";

$font_Geometria: Geometria, 'Geometria';

$color_background: #F6F6FB;
$color_Gray_1: #C5C5C9;
$color_Gray_2: #ABABB2;
$color_Gray_3: #8D909F;
$color_Gray_4: #EBEBEB;
$color_Gray_5: #F2F2F2;
$color_Gray_6: #F9F9F9;
$color_black: #333333;
$color_purple: #8C71FE;
$color_purple_2: #F2F1FF;
$color_purple_3: #E2E2F6;
$color_purple_4: #7B61EB;
$color_purple_5: #6F57D6;
$color_purple_6: #B1A1F2;
$color_red: #FF6597;
$color_green: #89CE54;
$color_grey: #AEBCD6;
$color_cyan: #C0CADC;
$color_cyan_2: #AEBCD6;
$color_cyan_3: #D1DBED;

$color_whiteHover: #fafafa;

$transition_medium: 0.5s ease;
$transition_fast: 0.25s ease;

#select-tariff__theme_default .module_help__theme_tutors svg path {
  transition: $transition_medium;
}

#select-tariff__theme_default .tariff_container .module_help__theme_tutors .svg:hover svg path {
  fill: $color_purple;
}
</style>

<style scoped lang="scss">
@import "../../../../../../style/styles_fonts";

$font_Geometria: Geometria, 'Geometria';

$color_background: #F6F6FB;
$color_Gray_1: #C5C5C9;
$color_Gray_2: #ABABB2;
$color_Gray_3: #8D909F;
$color_Gray_4: #EBEBEB;
$color_Gray_5: #F2F2F2;
$color_Gray_6: #F9F9F9;
$color_black: #333333;
$color_purple: #8C71FE;
$color_purple_2: #F2F1FF;
$color_purple_3: #E2E2F6;
$color_purple_4: #7B61EB;
$color_purple_5: #6F57D6;
$color_purple_6: #B1A1F2;
$color_red: #FF6597;
$color_green: #89CE54;
$color_grey: #AEBCD6;
$color_cyan: #C0CADC;
$color_cyan_2: #AEBCD6;
$color_cyan_3: #D1DBED;

$color_whiteHover: #fafafa;

$transition_medium: 0.5s ease;
$transition_fast: 0.25s ease;

$path_img_checkbox: '/lk/gk/img/check.svg';

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s ease;
}
.fade-enter-from, .fade-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.fadeFast-enter-active, .fadeFast-leave-active {
  transition: opacity .25s ease-in;
}
.fadeFast-enter-from, .fadeFast-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.fadeBackground-enter-active, .fadeBackground-leave-active {
  transition: opacity .25s ease;
}
.fadeBackground-enter-from, .fadeBackground-leave-to /* .fade-leave-active до версии 2.1.8 */ {
  opacity: 0;
}

.tariff_component .block_promocode__mobile {
  display: none;
}

.tariff_component .block_promocode__tablet {
  display: none;
}

.tariff_container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 32px;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;

  .switch .text__desktop {
    display: flex;
  }

  .switch .text__mobile {
    display: none;
  }
}

.tariff_container__padding_top {
  margin-top: 28px;
}

.module_help {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;

  .svg {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;

    .svg_absolute {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
    }
  }

  svg path {
    transition: $transition_medium;
  }
}

.help_popup {
  position: absolute;
  top: 24px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 450px;
  background-color: white;
  border: 1px solid rgba(0, 0, 0, 0.08);
  box-shadow: 0px 6px 8px -6px rgba(24, 39, 75, 0.12), 0px 8px 16px -6px rgba(24, 39, 75, 0.08);
  border-radius: 8px;
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 135%;
  color: $color_black;
  padding: 14px 18px;
  z-index: 5;
  text-transform: none;
  cursor: default;
}

.switch_container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.switch {
  display: flex;
  flex-direction: row;
  align-items: center;

  .module_help__theme_tutors {
    margin-left: 5px;
  }
}

.switch_text {
  display: flex;
  flex-direction: row;
  align-items: center;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  color: $color_cyan_2;
  transition: $transition_medium;
  min-width: 80px;
  cursor: pointer;

  &:hover {
    color: $color_purple;
  }
}

.switch_text__active {
  color: $color_purple;
}

.switch_text__first {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.switch_text__second {
  justify-content: flex-start;
}

.switch_block {
  margin: 0 14px;

  input[type="checkbox"].switch_1{
    font-size: 30px;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    width: 44px;
    height: 24px;
    border: 1px solid $color_cyan_3;
    background: rgba(255, 255, 255, 0);
    border-radius: 20px;
    position: relative;
    cursor: pointer;
    outline: none;
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  input[type="checkbox"].switch_1:checked{
    background: rgba(51, 51, 51, 0);
  }

  input[type="checkbox"].switch_1:after{
    position: absolute;
    content: "";
    width: 18px;
    height: 18px;
    border-radius: 50%;
    background: $color_purple;
    /*-webkit-box-shadow: 0 0 .25em rgba(0,0,0,.3);
    box-shadow: 0 0 .25em rgba(0,0,0,.3);*/
    left: 3px;
    -webkit-transition: all .2s ease-in-out;
    transition: all .2s ease-in-out;
  }

  /*input[type="checkbox"].switch_1:checked:after{
    left: calc(100% - 18px - 3px);
  }*/
}

.block__column {
  display: flex;
  flex-direction: column;
}

.block__row {
  display: flex;
  flex-direction: row;
  align-items: center;
}

// блок с промокодом
.sidebar_header {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 18px;
  color: $color_cyan_2;
  text-transform: uppercase;
  margin: 16px 24px 14px 24px;
}

.sidebar_border {
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 1px;
  background-color: rgba(0, 0, 0, 0.08);
}

.sidebar_item {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 16px;
  margin-top: 28px;
}

.block_promo {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: flex-start;
  grid-gap: 12px;
  margin: 20px 24px;
}

.promo_input {
  display: flex;
  flex-direction: row;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  height: 54px;
  padding: 0 20px;
  width: calc(100% - 40px);
  transition: $transition_medium;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: $color_black;
  font-family: $font-Geometria;
  outline: none;

  &:hover {
    border-color: $color_Gray_2;
  }

  &:focus {
    border-color: $color_purple;
  }
}

.promo_input:disabled:hover {
  border-color: rgba(0, 0, 0, 0.08);
}

.button__type_remove {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: $color_red;
  cursor: pointer;
  position: absolute;
  right: 12px;
  transition: $transition_medium;

  svg {
    width: 10px;
    height: 10px;
  }

  &:hover {
    background-color: #FF6597;
  }
}

.promo_button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  cursor: default;
  width: 56px;
  height: 56px;
  border-radius: 8px;
  transition: $transition_medium;
  background-color: $color_purple_2;
}

.promo_svg {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  svg path {
    fill: $color_purple;
    stroke: $color_purple;
    transition: $transition_medium;
  }
}

.promo_button__active {
  background-color: $color_purple;
  cursor: pointer;

  &:hover {
    background-color: $color_purple_4;
  }

  .promo_svg {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;

    svg path {
      fill: white;
      stroke: white;
    }
  }
}

.promo_button__applied {
  background-color: $color_green;
  cursor: default;

  svg path {
    stroke: white;
    fill: white;
  }
}

.promo_input::placeholder {
  font-family: $font-Geometria;
}

.package-select__margin_top {
  margin-top: 32px;
}

@media all and (max-width: 1600px) {
  .tariff_container {
    padding: 36px 28px;
    background-color: white;
  }

  .tariff_container__padding_top {
    margin-top: 24px;
  }

  .promo_input {
    height: 50px;
    padding: 0 18px;
    font-size: 15px;
    line-height: 19px;
  }

  .promo_button {
    width: 52px;
    height: 52px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  .module_help svg {
    width: 22px;
    height: 22px;
  }

  .help_popup {
    font-size: 14px;
    line-height: 18px;
    padding: 14px 18px;
  }

  // блок с промокодом
  .sidebar_item {
    margin-top: 24px;
  }

  .sidebar_header {
    font-size: 13px;
    line-height: 17px;
    margin: 16px 22px 12px 22px;
  }

  .promo_input {
    height: 50px;
    padding: 0 18px;
    width: calc(100% - 36px);
    font-size: 15px;
    line-height: 19px;
  }

  .promo_button {
    width: 52px;
    height: 52px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  .block_promo {
    margin: 18px 22px;
  }

  .package-select__margin_top {
    margin-top: 28px;
  }
}

@media all and (min-width: 1441px) {
  .switch_block input[type="checkbox"].switch_1:checked:after {
    left: calc(100% - 18px - 3px);
  }
}

@media all and (max-width: 1440px) {
  .tariff_container {
    padding: 34px 26px;
    background-color: white;
    border-radius: 10px;
  }

  .tariff_container__padding_top {
    margin-top: 21px;
  }

  .switch_text {
    font-size: 15px;
    line-height: 19px;
    min-width: 75px;
  }

  .switch_block input[type="checkbox"].switch_1 {
    width: 42px;
    height: 22px;
    border-radius: 20px;
  }

  .switch_block input[type="checkbox"].switch_1:after {
    width: 16px;
    height: 16px;
    left: 3px;
  }

  input[type="checkbox"].switch_1:checked:after{
    left: calc(100% - 16px - 3px);
  }

  .sidebar_item {
    margin-top: 21px;
    border-radius: 10px;
  }

  .promo_input {
    height: 46px;
    padding: 0 16px;
    font-size: 15px;
    line-height: 19px;
    border-radius: 6px;
  }

  .block_promo {
    grid-gap: 10px;
  }

  .promo_button {
    width: 48px;
    height: 48px;
    border-radius: 6px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  .module_help svg {
    width: 20px;
    height: 20px;
  }

  .help_popup {
    top: 22px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 18px;
    padding: 12px 16px;
  }

  // блок с промокодом
  .sidebar_header {
    font-size: 13px;
    line-height: 17px;
    margin: 14px 20px 10px 20px;
  }

  .block_promo {
    grid-gap: 10px;
    margin: 16px 20px;
  }

  .package-select__margin_top {
    margin-top: 24px;
  }
}

@media all and (max-width: 1280px) {
  .tariff_container {
    padding: 32px 24px;
  }

  .tariff_container__padding_top {
    margin-top: 18px;
  }

  .sidebar_item {
    margin-top: 18px;
  }

  .promo_input {
    height: 42px;
    padding: 0 16px;
    font-size: 14px;
    line-height: 18px;
  }

  .promo_button {
    width: 44px;
    height: 44px;
    border-radius: 6px;

    .promo_svg svg {
      width: 18px;
      height: auto;
    }
  }

  .help_popup {
    width: 350px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 17px;
    padding: 14px 16px;
  }

  // блок с промокодом
  .sidebar_header {
    font-size: 12px;
    line-height: 15px;
    margin: 14px 18px 10px 18px;
  }

  .promo_input {
    height: 42px;
    padding: 0 16px;
    width: calc(100% - 32px);
    font-size: 14px;
    line-height: 18px;
  }

  .promo_button {
    width: 44px;
    height: 44px;
    border-radius: 6px;

    .promo_svg svg {
      width: 18px;
      height: auto;
    }
  }

  .block_promo {
    margin: 16px 18px;
  }

  .button__type_remove {
    width: 18px;
    height: 18px;

    svg {
      width: 8px;
      height: 8px;
    }
  }
}

@media all and (max-width: 1160px) {
  .tariff_component .block_promocode__desktop {
    display: none;
  }

  .tariff_component .block_promocode__tablet {
    display: flex;
  }

  .tariff_container__padding_top {
    margin-top: 21px;
  }

  .promo_button {
    width: 48px;
    height: 48px;
    border-radius: 6px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  .module_help svg {
    width: 20px;
    height: 20px;
  }

  .help_popup {
    top: 22px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 18px;
    padding: 12px 16px;
    left: auto;
    right: 0;
  }

  // блок с промокодом
  .block_promocode {
    display: flex;
    flex-direction: column;
    margin-top: auto;
  }

  .sidebar_header {
    text-align: center;
    font-size: 13px;
    line-height: 17px;
    margin: 16px 0 14px 0;
  }

  .block_promocode .sidebar_header {
    text-align: start;
    font-size: 14px;
    line-height: 18px;
    padding: 0 24px;
  }

  .promo_input {
    height: 46px;
    padding: 0 16px;
    width: calc(100% - 32px);
    font-size: 15px;
    line-height: 19px;
    border-radius: 6px;
  }

  .block_promo {
    margin: 22px 24px 24px 24px;
    grid-gap: 10px;
  }

  .promo_button {
    width: 48px;
    height: 48px;
    border-radius: 6px;

    .promo_svg svg {
      width: 20px;
      height: auto;
    }
  }

  .button__type_remove {
    width: 22px;
    height: 22px;

    svg {
      width: 10px;
      height: 10px;
    }
  }

  .sidebar_item {
    margin-top: 21px;
  }

  .tariff_component .block_promocode__mobile {
    display: flex;
  }


}

@media all and (max-width: 960px) {
  .help_popup {
    width: 350px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 17px;
    padding: 14px 16px;
  }

  .sidebar_item {
    margin-top: 18px;
  }

  .sidebar_header {
    font-size: 12px;
    line-height: 15px;
    margin: 16px 0 14px 0;
  }

  .tariff_container__padding_top {
    margin-top: 18px;
  }
}

@media all and (max-width: 780px) {
  .tariff_container {
    padding: 30px 18px;
  }
}

@media all and (max-width: 720px) {
  .tariff_container {
    padding: 28px 20px;
  }
}

// mobile
@media all and (max-width: 600px) {
  .tariff_component .block__theme_mobile-steps {
    display: flex;
  }

  .tariff_component .block_promocode__tablet {
    display: none;
  }

  .tariff_container {
    border-radius: 8px;

    .switch .text__desktop {
      display: none;
    }

    .switch .text__mobile {
      display: flex;
    }
  }

  .sidebar_item {
    margin-top: 16px;
  }

  .tariff_container {
    padding: 0;
    background-color: rgba(51, 51, 51, 0);
    border: none;
    border-radius: 0;
  }

  .tariff_container__padding_top {
    margin-top: 16px;
  }

  .switch_container {
    display: flex;
    width: 100%;
    height: 48px;
    border-radius: 6px;
    background-color: white;
    border: 1px solid rgba(0, 0, 0, 0.08);
  }

  .main_content {
    grid-gap: 16px;
  }

  .block_promocode .sidebar_header {
    text-align: start;
    margin-bottom: 4px;
    text-transform: none;
    font-size: 13px;
    line-height: 17px;
  }

  .promo_input {
    height: 42px;
    padding: 0 16px;
    width: calc(100% - 32px);
    font-size: 14px;
    line-height: 18px;
  }

  .promo_button {
    width: 44px;
    height: 44px;
    border-radius: 6px;

    .promo_svg svg {
      width: 18px;
      height: auto;
    }
  }

  .button__type_remove {
    width: 20px;
    height: 20px;

    svg {
      width: 9px;
      height: 9px;
    }
  }

  .swiper-slide {
    width: 280px;
  }

  .switch_text {
    font-size: 14px;
    line-height: 18px;
    min-width: auto;
  }

  .switch_block {
    margin: 0 9px;
  }

  .switch_block input[type="checkbox"].switch_1:after {
    width: 14px;
    height: 14px;
    left: 3px;
  }

  input[type="checkbox"].switch_1:checked:after {
    left: calc(100% - 14px - 3px);
  }

  .switch_block input[type="checkbox"].switch_1 {
    width: 38px;
    height: 20px;
    border-radius: 20px;
  }

  .sidebar_header {
    padding: 0 14px;
  }

  .sidebar_item {
    border-radius: 8px;
  }

  .sidebar_row {
    grid-gap: 8px;
  }

  .help_popup {
    top: 24px;
    width: 270px;
    border-radius: 6px;
    font-size: 13px;
    line-height: 17px;
    padding: 14px;
  }

  .module_help svg {
    width: 18px;
    height: 18px;
  }

  // блок с промокодом
  .main_container .block_promocode {
    padding: 0;
    border: 1px solid rgba(0, 0, 0, 0.08);
    border-radius: 8px;
    background-color: white;
  }

  .block_promocode .sidebar_header {
    margin: 12px 14px 10px 14px;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 15px;
    padding: 0;
  }

  .block_promo {
    margin: 15px 14px;
  }

  .package-select__margin_top {
    margin-top: 16px;
  }
}

@media all and (max-width: 400px) {
  .switch .help_popup {
    width: 250px;
  }
}

@media all and (max-width: 360px) {
  .swiper-slide {
    width: 270px;
  }

  .switch .help_popup {
    width: 235px;
  }
}

@media all and (max-width: 340px) {
  .swiper-slide {
    width: 260px;
  }
}

</style>